var v1="<span ng-if=\"!editMode\">{{ score.water_hazard != 0 ? score.water_hazard : '' }}</span><span ng-if=\"editMode\" class=\"column-input\"><span gnp-custom-select=\"\" empty-value=\"true\" ng-model=\"score.water_hazard\" disable=\"!isShotEntered(score)\" options=\"defaultData.ob_waterOptions\" class=\"input gray\"></span></span>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("score-card/templates/water.jade", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ngapp/javascript/web/components/score-card/templates/water.jade
// module id = 407
// module chunks = 0